export default __webpack_public_path__ + "static/media/facebook.74f5a502.svg";